import { render, staticRenderFns } from "./FacebookButton.vue?vue&type=template&id=7218bb32"
import script from "./FacebookButton.vue?vue&type=script&lang=js"
export * from "./FacebookButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports